/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import ChangeoverModel from 'uplisting-frontend/models/changeover';

interface IArgs {
  changeover: ChangeoverModel;
}

export interface ChangeoverSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

export default class UiChangeoverComponent extends Component<ChangeoverSignature> {
  @service router!: Services['router'];

  @cached
  get changeover(): ChangeoverModel {
    return this.args.changeover;
  }

  @cached
  get currentRouteName(): string {
    return this.router.currentRouteName ?? '';
  }

  @cached
  get summaryRoute(): string {
    if (this.currentRouteName.startsWith('action.changeovers')) {
      return 'action.changeovers.summary';
    }

    return '';
  }

  @cached
  get hostRoute(): string {
    if (this.currentRouteName.startsWith('action.changeovers')) {
      return 'action.changeovers.host';
    }

    return '';
  }

  @cached
  get indexRoute(): string {
    if (this.currentRouteName.startsWith('action')) {
      return 'action';
    }

    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Changeover': typeof UiChangeoverComponent;
  }
}
